import { configureStore } from '@reduxjs/toolkit'
import { persistedReducer } from './root-reducer'
import persistStore from 'redux-persist/es/persistStore'
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store)
export const useSelector = useReduxSelector;
export const useDispatch = () => useReduxDispatch();
